import { calendarNotificationsBarSetCalendarColor } from 'owa-locstrings/lib/strings/calendarnotificationsbarsetcalendarcolor.locstring.json';
import { tryAgainLabel } from 'owa-locstrings/lib/strings/tryagainlabel.locstring.json';
import loc, { format } from 'owa-localize';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { ControlIcons } from 'owa-control-icons';
import { CalendarEntry } from 'owa-graph-schema';
import { lazyShowCalendarNotification } from 'owa-calendar-notification-bar';
import { calendarNotificationsBarSetCalendarColorFailed } from 'owa-locstrings/lib/strings/calendarnotificationsbarsetcalendarcolorfailed.locstring.json';
import { trace } from 'owa-trace';
import { setCalendarHexColor } from 'owa-calendar-surface-calendars-store';
import {
    updateCalendarColor,
    setCalendarHexColorService,
    showCalendarErrorNotification,
} from 'owa-calendar-update';
import { orchestrator } from 'satcheljs';
/**
 * Validates that start and end times are valid and replaces them in the Calendar Event
 */
export let setCalendarHexColorOrchestrator = orchestrator(
    setCalendarHexColor,
    async actionMessage => {
        let calendar: CalendarEntry = actionMessage.calendar;
        let newColor: string = actionMessage.newColor;

        let oldColors = calendar.colorScheme;
        if (calendar.CalendarColor == -1) {
            oldColors = null;
        }

        // For group calendars, we don't want to make a server call as we don't have the mechanism to support this.
        // Instead, we will only set the color in the cache so that this color is atleast valid for the current session.
        if (calendar.calendarId.mailboxInfo.type == 'GroupMailbox') {
            updateCalendarColor(calendar, newColor);
        } else {
            lazyShowCalendarNotification.import().then(showCalendarNotification => {
                showCalendarNotification(
                    'setCalendarHexColor',
                    'Surface',
                    format(loc(calendarNotificationsBarSetCalendarColor), calendar.CalendarName),
                    { icon: ControlIcons.Save }
                );
            });

            const result = await executeUpdateCalendarHexColorRequest(calendar, newColor);

            if (!result) {
                onRequestFailed(calendar, oldColors, newColor);
            }
        }
    }
);

async function executeUpdateCalendarHexColorRequest(calendar: CalendarEntry, newColor: string) {
    updateCalendarColor(calendar, newColor);

    try {
        const result = await setCalendarHexColorService(calendar.calendarId, newColor);

        if (result != null) {
            trace.info(
                `[setCalendarHexColor] Successfully set new calendar color, calendar: ${calendar.CalendarName}, color: ${newColor}`
            );
        }

        return result;
    } catch (e) {
        return null;
    }
}

function onRequestFailed(calendar: CalendarEntry, oldColors: ColorScheme, newColor: string) {
    return () => {
        const color = oldColors ? oldColors.calPrimary : '';
        updateCalendarColor(calendar, color);

        showCalendarErrorNotification(
            'setCalendarHexColor',
            format(loc(calendarNotificationsBarSetCalendarColorFailed), calendar.CalendarName),
            ControlIcons.Error,
            loc(tryAgainLabel),
            () => setCalendarHexColor(calendar, newColor)
        );
    };
}
